import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import AppStore from '../../AppStore';
import AppActions from '../../AppActions';

import history from '../../history';
import * as Utilities from '../../Utilities';

export default class OptionsHeader extends Reflux.Component {
    constructor (state) {
        super(state);
        this.store = AppStore;
    }

    getNextRank = (e) => {
        let url = '';
        if (this.state.globalTopic && this.state.relatedTopics[0]) {
            url = Utilities.getHumanUrl(this.state.relatedTopics[0]);
            return history.push('/topic/' + url);
        }
        if (this.state.currentTopic.nextTop) {
            url = Utilities.getHumanUrl({id: this.state.currentTopic.nextTop, title: this.state.currentTopic.title});
            return history.push('/topic/' + url);
        }
    }

    getPrevRank = (e) => {
        let url = '';
        if (this.state.globalTopic && this.state.relatedTopics[0]) {
            url = Utilities.getHumanUrl(this.state.relatedTopics[0]);
            return history.push('/topic/' + url);
        }
        if (this.state.currentTopic.prevTop) {
            let url = Utilities.getHumanUrl({id: this.state.currentTopic.prevTop, title: this.state.currentTopic.title});
            return history.push('/topic/' + url);
        }
    }
    isCreator = () => {
        if (this.state.userData && this.state.currentTopic && this.state.currentTopic.createdBy) {
            return (this.state.currentTopic.createdBy.username === this.state.userData.username);
        }
        return false;
    }
    goToMyTopic = () => {
        return history.push('/topic/' + Utilities.getHumanUrl(this.state.sameTopicByMe));
    }
    makeTop = () => {
        let isCreator = this.isCreator();
        let isSameTopicByMe = this.state.isSameTopicByMe;
        if (isSameTopicByMe && !isCreator) {
            this.goToMyTopic();
        } else {
            AppActions.enableEdition();
        }
    }
    render () {
        if (this.state.currentTopic) {
            return (
              <div>
                <div className='arrowTopic'>
                  <a className={'leftarrow waves-effect waves-light ' + (this.state.currentTopic.prevTop ? '' : 'active-creation')}
                    data-tip='Anterior Top5' data-for='ant-btn' onClick={(e) => this.getPrevRank(e)}><i className='fa fa-angle-left' aria-hidden='true' /></a>
                  <ReactTooltip place='top' type='dark' effect='solid' id='ant-btn' />
                  <a className={'rightarrow waves-effect waves-light ' + (this.state.currentTopic.nextTop || this.state.globalTopic ? '' : 'active-creation')}
                    data-tip='Siguiente Top5' data-for='sig-btn' onClick={(e) => this.getNextRank(e)}><i className='fa fa-angle-right' aria-hidden='true' /></a>
                  <ReactTooltip place='top' type='dark' effect='solid' id='sig-btn' />
                </div>
                {this.state.currentTopic.title &&
                <div className='globalBtn-contain'>
                  <Link type='button' to={'/topic/g_' + this.state.currentTopic.title.replace(/ /g, '-')} className={this.state.globalTopic
                      ? 'btn-global waves-effect waves-light active'
                      : 'btn-global waves-effect waves-light'} data-type='global'>
                    <img src='/images/icons/america-planet.svg' />
                    <span>Global</span>
                  </Link>
                </div>
                }
                <div className='newTop-contain'>
                  <a type='button' className={'btn-primary waves-effect waves-light createTopBtn ' + (this.state.enableEditing
                    ? 'active-creation'
                    : '')} onClick={this.makeTop} data-type='own'>
                    <i className='fa fa-pencil' aria-hidden='true' />
                    {this.isCreator() ? 'Editar' : this.state.isSameTopicByMe ? 'Ir a mi top' : 'Participar'}</a>
                </div>
              </div>
            );
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/topic/OptionsHeader.js